"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
const TokenValidationStyle_1 = __importDefault(require("./styles/TokenValidationStyle"));
const material_1 = require("@mui/material");
const TokenValidation = () => {
    const classes3 = (0, TokenValidationStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { layoutStatus } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const handleToggleCloseTokenValidation = (cancel) => {
        console.log('handleToggleCloseTokenValidation');
        dispatch((0, login2FAAction_1.toggleCloseTokenValidation)(cancel));
    };
    const fontFamilyConst = '"Open Sans", Helvetica,Arial,sans-serif';
    return (react_1.default.createElement(material_1.Dialog, { open: layoutStatus === types_1.LayoutStatus.TOKEN_VALIDATION, classes: { paper: classes3.dialog }, TransitionComponent: material_1.Slide, onClose: () => console.log('dismiss') },
        react_1.default.createElement(material_1.Typography, { className: classes3.Error2FATitle, style: { margin: '30px 0 0', fontWeight: 600 } },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-token-validation-title" })),
        react_1.default.createElement(material_1.ListItem, { className: classes3.ListItem, style: { width: 'auto' } },
            react_1.default.createElement(material_1.ListItemIcon, { className: classes3.WrapIcon }),
            react_1.default.createElement(material_1.ListItemText, null,
                react_1.default.createElement(material_1.Typography, { className: classes3.typography, style: {
                        marginLeft: '-5px',
                        fontSize: '12px',
                        lineHeight: '1',
                        fontFamily: fontFamilyConst,
                        fontWeight: 600
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-token-validation-content1" })),
                react_1.default.createElement(material_1.Typography, { className: classes3.typography, style: {
                        marginLeft: '-5px',
                        fontSize: '12px',
                        lineHeight: '1',
                        fontFamily: fontFamilyConst,
                        fontWeight: 600
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-token-validation-content2" })),
                react_1.default.createElement(material_1.Typography, { className: classes3.typography, style: {
                        marginLeft: '-5px',
                        fontSize: '12px',
                        lineHeight: '1',
                        fontFamily: fontFamilyConst,
                        fontWeight: 600
                    } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-token-validation-content3" })))),
        react_1.default.createElement(material_1.Button, { className: classes3.OK, style: { minWidth: '115px', color: 'white', margin: '15px 0' }, name: "submit", disableTouchRipple: true, disableFocusRipple: true, onClick: () => handleToggleCloseTokenValidation(false) },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-token-validation-btn-ok" }))));
};
exports.default = TokenValidation;
